import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { CoreService } from '../services/core.service';

@Injectable({
    providedIn: 'root'
})
export class NoauthGuard implements CanActivate {
    session_info: SessionInfo

    constructor(public title_service: Title, private coreService: CoreService) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (this.coreService.isLoggedIn()) {
            this.coreService.goHome()
            return false
        }
        const page_titles: Array<string> = []
        if (next.data.page_title) {
            page_titles.push(next.data.page_title)
        }
        this.title_service.setTitle(page_titles.join(" | "));
        return true;
    }

}
